export const Types = {
    GET_PHYSICAL_ACTIVITY: "GET_PHYSICAL_ACTIVITY",
    GET_SLEEP_MEASURES: "GET_SLEEP_MEASURES",
    GET_EVS_FACTORS:"GET_EVS_FACTORS"
  };